import React, { useState } from "react";
import "./Banner_Btn_Component.css";
import Green_Btn from "../../common_components/common_btn/green_btn/Green_Btn";
import Alert_Modal from "../../common_components/common_modal/alert_modal/Alert_Modal";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import "swiper/css/autoplay";
const Banner_Btn_Component = ({ addBanners }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="Banner_Btn_Component">
      <div className="banner_div">
        {/* {addBanners?.[1]?.image ? ( */}
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          loop={true} // continuous loop
          autoplay={{
            delay: 2000, // slide delay (2 sec)
            disableOnInteraction: false, // continue autoplay after user interaction
          }}
          modules={[Autoplay]}
        >
          {addBanners?.map((val) => (
            <SwiperSlide>
              <div className="img_div">
                <img
                  src={process.env.REACT_APP_IMG_URL + val?.image}
                  // src="/assets/images/home/banner_with_btn/banner.png"
                  className="banner_img"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* ) : null} */}

        {/* <div className='content_div'>

                    <p className='title_text'>Paan Corner</p>
                    <p className='subtext'>All delighting flavours now on your finger tips!</p>

                    <div className='shop_btn'>
                        <Green_Btn btn_name="Shop Now" onClick={() => {setShowModal(true)}}/>
                    </div>
                </div> */}
      </div>

      <Alert_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        successText="Order canceled successfully!"
      />
    </section>
  );
};

export default Banner_Btn_Component;
